module.exports = __webpack_public_path__ + "static/media/Promotion_Card_JP.e979f1e6.jpg";